import React from "react";
import { CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { heightPercentsToPx } from "../../util/helpers";

const useStyles = makeStyles(() => ({
  paper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: heightPercentsToPx(100)
  }
}));

const Loader: React.FunctionComponent = () => {
  const classes = useStyles();

  return (
    <div className={classes.paper}>
      <CircularProgress />
    </div>
  );
};

export default Loader;
